import { defineStore } from 'pinia';

import actions from './actions';
import state from './state';

// eslint-disable-next-line import/prefer-default-export
export const currentVideoSession = defineStore('currentVideoSession', {
  state,
  actions,
});
